import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BatchStateRequest, CheckBatchHistoryRequest } from '@/api';
import { CheckBatchHistoryData, CheckBatchHistoryItem } from '../models';

export interface CheckBatchSliceState {
  data: CheckBatchHistoryData;
  loading: boolean;
  error: string | null;
}

const initialState: CheckBatchSliceState = {
  data: null,
  loading: false,
  error: null,
};

const checkBatchSlice = createSlice({
  name: 'checkBatch',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    setData: (state, action: PayloadAction<CheckBatchHistoryData>) => ({
      ...state,
      data: action.payload,
    }),
    fetchBatchHistory: (
      state,
      action: PayloadAction<CheckBatchHistoryRequest>,
    ) => ({
      ...state,
      error: null,
      loading: true,
    }),
    fetchBatchItem: (state, action: PayloadAction<BatchStateRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    refreshDataItem: (state, action: PayloadAction<CheckBatchHistoryItem>) => {
      if (state.data?.items) {
        const currentItems: CheckBatchHistoryItem[] = JSON.parse(
          JSON.stringify(state.data?.items || []),
        );
        const newItems = [...currentItems];

        if (action.payload) {
          const itemIndex = currentItems.findIndex(
            (item) => item.id === action.payload.id,
          );

          if (itemIndex !== -1) {
            newItems.splice(itemIndex, 1, action.payload);
          }
        }

        state.data.items = newItems;
      }
    },
  },
});

export { checkBatchSlice };
